/**
 * Welchen Stil die Ego-Ansicht zeigt, wenn nicht der aus der Map.
 *
 * Die Map bleibt unangetastet: ihr `theme`-Feld sagt weiterhin `"flat"`, die
 * Draufsicht bleibt das Buero. Die Ego-Ansicht zeigt von sich aus das
 * Gewoelbe; wer etwas anderes will, waehlt es im Einstellungs-Popover unter
 * "3D-Stil". Die Wahl bleibt fuer dieses Geraet bestehen, wie
 * Blickempfindlichkeit und Deckenanzeige auch.
 *
 * Daneben gibt es weiterhin `?theme3d=<name>` in der Adresse. Das ist der
 * Weg zu `plain`, dem flachen Buero-Stil, den die Einstellungen bewusst
 * nicht anbieten. Beide Wege schreiben denselben Speicherplatz.
 *
 * Gelesen wird hier nur beim Start; danach fuehrt der `viewStore` die Wahl.
 */

const SCHLUESSEL = 'etown.theme3d';

/**
 * Liest die Wahl und schreibt sie fort, wenn sie in der Adresse steht.
 * Ohne Wahl gilt, was die Map sagt.
 */
export function theme3dWahl(): string | null {
  let ausAdresse: string | null = null;
  try {
    ausAdresse = new URLSearchParams(window.location.search).get('theme3d');
  } catch {
    /* keine Adresse verfuegbar: dann zaehlt nur der Speicher */
  }

  if (ausAdresse !== null) {
    const gewaehlt = ausAdresse.trim().toLowerCase();
    try {
      if (gewaehlt) window.localStorage.setItem(SCHLUESSEL, gewaehlt);
      else window.localStorage.removeItem(SCHLUESSEL);
    } catch {
      // Gesperrter Speicher: die Wahl gilt dann nur fuer diesen Aufruf
    }
    return gewaehlt || null;
  }

  try {
    return window.localStorage.getItem(SCHLUESSEL);
  } catch {
    return null;
  }
}

/**
 * Eine ausdrueckliche Wahl festschreiben — der Gegenpart zum Leser oben,
 * damit dieser Speicherplatz eine einzige zustaendige Datei behaelt.
 *
 * Dabei wird ein noch in der Adresse stehendes `?theme3d=` entfernt. Ohne
 * das wuerde die Adresse die neue Wahl beim naechsten Laden wieder
 * ueberstimmen: man stellt im Popover etwas ein, laedt neu und bekommt
 * kommentarlos den alten Stil zurueck.
 */
export function schreibeTheme3dWahl(wahl: string | null): void {
  try {
    if (wahl) window.localStorage.setItem(SCHLUESSEL, wahl);
    else window.localStorage.removeItem(SCHLUESSEL);
  } catch {
    // Gesperrter Speicher: die Wahl gilt dann nur fuer diese Sitzung
  }

  try {
    const adresse = new URL(window.location.href);
    if (!adresse.searchParams.has('theme3d')) return;
    adresse.searchParams.delete('theme3d');
    window.history.replaceState(null, '', adresse);
  } catch {
    // Keine Adresse verfuegbar: dann steht dort auch nichts im Weg
  }
}
